import React from 'react';
import DropDown from '../DropDown';
import Switch from 'react-toggle-switch';
import SaleCallChartSettings from './SaleCallChartSettings';

function ColumnChartWidgetSettings({ widget, setWidgetFieldValue }) {

    let salesChartContent;
    let otherChartContent;
    if(widget.widgetType == 'saleCall'){
        salesChartContent = <SaleCallChartSettings widget={widget} setWidgetFieldValue={setWidgetFieldValue}/>;
    }else {
        otherChartContent = (widget.dataConfig.dividedBy === 'user') ? (
            <div className='displaySettings-row'>
                <span className="label">Etikettutseende</span>
                <DropDown
                    setWidgetFieldValue={setWidgetFieldValue}
                    field="displayConfig.labelType"
                    options={[
                        {
                            title: 'Bild och text',
                            value: 'pictureAndText',
                        },
                        {
                            title: 'Endast bild',
                            value: 'picture',
                        },
                        {
                            title: 'Endast text',
                            value: 'text',
                        },
                    ]}
                    widget={widget}
                />
            </div>)
            :
            (<div className='displaySettings-row'>
                <span className="label">Etikettutseende</span>
                <select
                    className="form-control"
                    title="Du kan endast visa text när du inte har valt att dela upp data eller delar på roll"
                    disabled
                >
                    <option>Endast text</option>
                </select>
            </div>);
    }

    return (
    <div>
        {salesChartContent ? salesChartContent : otherChartContent}

        {!salesChartContent && 
        <div>
            <div className="displaySettings-row">
                <span className="title">Budget</span>
                <input
                    className="form-control"
                    type="text"
                    placeholder="Hämta från Upsales"
                    value={(''+_.get(widget, 'displayConfig.budget', '')).replace(/\B(?=(\d{3})+(?!\d))/g, ' ')}
                    onChange={(event) => {
                        const val = parseInt(event.target.value.replace(/\D/g, ''), 10);
                        setWidgetFieldValue(
                            'displayConfig.budget',
                            val >= 0 ? val : ''
                        );
                    }}
                />
            </div>
            <div className='displaySettings-row'>
                <span className="label">Filtrera bort 0-resultat</span>
                <Switch
                    onClick={() => {
                        setWidgetFieldValue(
                            'displayConfig.zeroFilter', 
                            !_.get(widget, 'displayConfig.zeroFilter', false)
                        );
                    }}
                    on={_.get(widget, 'displayConfig.zeroFilter', false)}
                />
            </div>
        </div>}
    </div>);
}

ColumnChartWidgetSettings.propTypes = {
    widget: React.PropTypes.object,
    setWidgetFieldValue: React.PropTypes.func,
};

export default ColumnChartWidgetSettings;



/** WEBPACK FOOTER **
 ** ./client/components/SettingsModal/DisplaySettings/ColumnChartWidgetSettings.jsx
 **/